import React, { useEffect, useRef, useState } from 'react';
import { Alert, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Block, BlockBetween, BlockHeadContent, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../Component';
import { EMPTYNULLREGEX, messageToast } from '../../utils/Utils';
import AuthTenantPageError from '../../pages/error/AuthTenantPageError';
import AuthTenantLoader from '../../pages/loaders/AuthTenantLoader';
import * as app_consts from "../../utils/app_consts";
import AuthTenantNoData from '../../pages/error/AuthTenantNoData';
import { RETRIEVE_TENANT_STOCK_TAKE_PREVIEW_DETAILS_API, TENANT_SUBMIT_STOCK_TAKE_REPORT_API } from '../../api/api_data';
import { useParams } from 'react-router';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { useDispatch } from 'react-redux';
import { fail_retrieve_tenant_stock_take_preview_details, loading_retrieve_tenant_stock_take_preview_details, reset_retrieve_tenant_stock_take_preview_details, success_retrieve_tenant_stock_take_preview_details } from '../../reducers/auth_tenant/retrieve_tenant_stock_take_preview_details_Slice';
import { RETRIEVE_TENANT_STOCK_TAKE_PREVIEW_DETAILS, RETRIEVE_TENANT_STOCK_TAKE_PREVIEW_DETAILS_ERROR_MSG, TENANT_SUBMIT_STOCK_TAKE_REPORT_ERROR_MSG, TENANT_SUBMIT_STOCK_TAKE_REPORT_SUCCESS_MSG } from '../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { fail_tenant_submit_stock_take_report, loading_tenant_submit_stock_take_report, reset_tenant_submit_stock_take_report, success_tenant_submit_stock_take_report } from '../../reducers/auth_tenant/tenant_submit_stock_take_report_Slice';
import CardTabs from '../../pages/components/cards/CardTabs';

const initialState = { csv_file: "", reference_number: "", csv_data: "" };
const csv_headers = ["product_id", "product_name", "color", "size", "product_type", "category", "product_value", "physical_stock"];

const UploadStockTakeReportModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

  const [open, setOpen] = useState(isOpen);
  const [form_data, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState([]);
  const [loading_message, setLoadingMessage] = useState("");
  const [view_csv_file_data, setViewCsvFileData] = useState([]);
  const [failed_imports, setFailedImports] = useState([]);
  const [successImports, setSuccessImports] = useState([]);
  const [imported_data, setImportedData] = useState([]);
  const [imported_data_list, setImportedDataList] = useState([]);
  const [successImportsPerPage] = useState(200);
  const [currentSuccessImportsPage, setSuccessImportsPage] = useState(1);
  const successImportsPaginate = (pageNumber) => setSuccessImportsPage(pageNumber);
  const fileInputRef = useRef(null);
  const [failedImportsPerPage] = useState(200);
  const [currentFailedImportsPage, setSuccessFailedImportsPage] = useState(1);
  const failedImportsPaginate = (pageNumber) => setSuccessFailedImportsPage(pageNumber);
  const { reference_number } = useParams();
  const dispatch = useDispatch();
  const [preview_set, setPreviewSet] = useState(false);
  const [uploaded_file, setUploadedFile] = useState('');
  const [activeCardTab, setActiveCardTab] = useState("Valid Data (To Be Imported)");

  const tabs = [
    {
      tabName: "Valid Data (To Be Imported)"
    },
    {
      tabName: "Invalid Data (Not To Be Imported)"
    }
  ];



  const handleReUploadClick = () => {
    if (fileInputRef.current)
    {
      fileInputRef.current.click();
    }
  };

  useEffect(() => {
    setOpen(isOpen);
    setFormData(initialState);

    if (isOpen)
    {
      setSuccessImports([]);
      setFailedImports([]);
      setImportedDataList([]);
      setImportedData([]);
      setUploadedFile('');
    }

  }, [isOpen]);

  const handleCsvUpload = (event) => {
    setError("");
    setPreviewSet(false);

    const file = event?.target?.files[0];
    const reader = new FileReader();
    setUploadedFile(file);

    setLoading(true);
    reader.onload = (e) => {
      const csv_data = e?.target?.result;

      convertToJson(csv_data);
    };

    reader?.readAsText(file);
  };

  const convertToJson = (csv_data) => {
    const lines = csv_data.split("\n");
    setLoadingMessage("Reading CSV File");

    // Extract the Column Headers
    const headers = lines[0]?.split(",")?.map(header => header.replace(/"/g, '')?.trim());
    // Validate the headers
    const headersMatch = csv_headers.every((header, index) => header === headers[index]);

    if (!headersMatch)
    {
      messageToast("Invalid headers", app_consts.FAIL);
      setLoading(false);
      setLoadingMessage("");
    } else
    {

      const result = [];
      for (let i = 1; i < lines?.length; i++)
      {
        const currentLine = lines[i].split(",").map(field => field.trim());

        // Check if the row is empty or contains only whitespace
        if (currentLine.every(field => field === ""))
        {
          continue;
        }

        const obj = {};
        // Loop Through Each Column and Match the Headers
        for (let j = 0; j < headers.length; j++)
        {
          obj[headers[j]] = currentLine[j];
        }

        result.push(obj);
      }

      // 
      const csv_timer = setTimeout(() => {
        if (result?.length > 0)
        {
          setImportedData(result);
          setImportedDataList(result);
        }
        else
        {
          messageToast("No Data has been Found.", app_consts.FAIL);
          setLoading(false);
        }
      }, 1000);

      return () => clearTimeout(csv_timer); // cleanup in case the component unmounts
    }
  };


  useEffect(() => {
    if (imported_data?.length > 0)
    {
      // Start Duplicate Check
      validate_uploaded_csv_data(imported_data[0]);
    }
    else
    {
      setLoadingMessage("");
      // Check Imported Data list
      checkImportedDataList();
      // setViewCsvFileData([]);
    }
  }, [imported_data]);

  const checkImportedDataList = () => {
    if ((failed_imports?.length + successImports?.length) === (imported_data_list?.length) && imported_data_list?.length !== 0)
    {
      setLoading(false);
    }
  };

  const validate_uploaded_csv_data = (stock_take_data) => {
    let copy_stock_take_data = stock_take_data;
    const errors = [];
    // Make Sure That No Empty Data

    const fields = [
      { key: "product_id", label: "Product Id is Required" },
      { key: "product_name", label: "Product Name is Required" },
      { key: "color", label: "Color is Required" },
      { key: "size", label: "Size is Required" },
      { key: "product_type", label: "Product Type is Required" },
      { key: "physical_stock", label: "Product Physical Stock is Required" },
      { key: "category", label: "Brand is Required" },
    ];


    fields.forEach(({ key, label }) => {
      const isInvalid = EMPTYNULLREGEX.test(copy_stock_take_data?.[key]);
      if (isInvalid)
      {
        errors.push(label);
      }
    });

    // Check for Duplicates
    const duplicate = imported_data?.filter((data) => {
      const data_product_id = data?.product_id?.toString().trim().toLowerCase();
      const data_color = data?.color?.toString().trim().toLowerCase();
      const data_size = data?.size?.toString().trim().toLowerCase();

      const stock_product_id = copy_stock_take_data?.product_id?.toString().trim().toLowerCase();
      const stock_color = copy_stock_take_data?.color?.toString().trim().toLowerCase();
      const stock_size = copy_stock_take_data?.size?.toString().trim().toLowerCase();

      return (
        data_product_id === stock_product_id &&
        data_color === stock_color &&
        data_size === stock_size
      );
    });

    if (duplicate?.length > 1)
    {
      errors.push("Duplicate Entry");
    }

    // const new_data = {
    //   ...copy_stock_take_data,
    //   product_id: JSON.parse(copy_stock_take_data?.product_id || 'null'),
    //   product_name: JSON.parse(copy_stock_take_data?.product_name || 'null'),
    //   color: JSON.parse(copy_stock_take_data?.color || 'null'),
    //   size: JSON.parse(copy_stock_take_data?.size || 'null'),
    //   product_type: JSON.parse(copy_stock_take_data?.product_type || 'null'),
    //   category: JSON.parse(copy_stock_take_data?.category || 'null'),
    //   physical_stock: JSON.parse(copy_stock_take_data?.physical_stock || 'null'),
    // };

    console.log(errors);

    if (errors?.length > 0)
    {
      // Add Errors to Failed Imports
      const updated_data = { ...copy_stock_take_data, errors: errors };
      setFailedImports([...failed_imports, { ...updated_data }]);
    }
    else
    {
      setSuccessImports([...successImports, { ...copy_stock_take_data }]);
    }

    // Update Import Data
    const updated_import_data = imported_data?.filter((detail, index) => index !== 0);

    setImportedData(updated_import_data);

  };

  const indexOfLastSuccessImport = currentSuccessImportsPage * successImportsPerPage;
  const indexOfFirstSuccessImport = indexOfLastSuccessImport - successImportsPerPage;
  const currentSuccessImports = successImports?.slice(indexOfFirstSuccessImport, indexOfLastSuccessImport);

  const indexOfLastFailedImport = currentFailedImportsPage * failedImportsPerPage;
  const indexOfFirstFailedImport = indexOfLastFailedImport - failedImportsPerPage;
  const currentFailedImports = failed_imports?.slice(indexOfFirstFailedImport, indexOfLastFailedImport);

  const [toggleClick, setToggleClick] = useState({ toggleClick: false, selectedIndex: null });

  const toggleClickFunc = (index) => {
    setToggleClick((prev) => ({
      toggleClick: prev.selectedIndex === index ? { toggleClick: false, selectedIndex: null } : { toggleClick: true, selectedIndex: index }
    }));
  };

  const handleSubmitForPreview = () => {
    setError("");
    setLoading(true);
    setLoadingMessage("Processing Preview Data");

    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_stock_take_preview_details, success_retrieve_tenant_stock_take_preview_details, fail_retrieve_tenant_stock_take_preview_details, RETRIEVE_TENANT_STOCK_TAKE_PREVIEW_DETAILS_ERROR_MSG, RETRIEVE_TENANT_STOCK_TAKE_PREVIEW_DETAILS, app_consts.POST, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_STOCK_TAKE_PREVIEW_DETAILS_API}`, { reference_number: reference_number /* products: successImports */, product_file: uploaded_file }));
  };

  // Listener
  const retrieve_tenant_stock_take_preview_details_listener = useSelector((state) => state.retrieve_tenant_stock_take_preview_details.retrieve_tenant_stock_take_preview_details);

  useEffect(() => {
    if (retrieve_tenant_stock_take_preview_details_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_stock_take_preview_details_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoadingMessage("");
        if (retrieve_tenant_stock_take_preview_details_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_tenant_stock_take_preview_details_listener.message);
          messageToast(retrieve_tenant_stock_take_preview_details_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_stock_take_preview_details_listener.status === app_consts.SUCCESS)
        {
          setSuccessImports(retrieve_tenant_stock_take_preview_details_listener.data?.products);
          setPreviewSet(true);
          setFailedImports([]);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_tenant_stock_take_preview_details());
      }
    }
  }, [retrieve_tenant_stock_take_preview_details_listener]);

  const submit_stock_take_report = () => {
    setLoadingMessage("Submitting Stock Take Report");
    setError("");

    dispatch(tenant_auth_actions_helper(loading_tenant_submit_stock_take_report, success_tenant_submit_stock_take_report, fail_tenant_submit_stock_take_report, TENANT_SUBMIT_STOCK_TAKE_REPORT_ERROR_MSG, TENANT_SUBMIT_STOCK_TAKE_REPORT_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_SUBMIT_STOCK_TAKE_REPORT_API}`, { reference_number: reference_number /* products: successImports */, product_file: uploaded_file }));
  };

  // Listener
  const tenant_submit_stock_take_report_listener = useSelector((state) => state.tenant_submit_stock_take_report.tenant_submit_stock_take_report);

  useEffect(() => {
    if (tenant_submit_stock_take_report_listener.status !== app_consts.IDLE)
    {
      if (tenant_submit_stock_take_report_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoadingMessage("");
        if (tenant_submit_stock_take_report_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(tenant_submit_stock_take_report_listener.message);
          messageToast(tenant_submit_stock_take_report_listener.message, app_consts.FAIL);
        } else if (tenant_submit_stock_take_report_listener.status === app_consts.SUCCESS)
        {
          setLoading(false);
          successFunction();
        }
        dispatch(reset_tenant_submit_stock_take_report());
      }
    }
  }, [tenant_submit_stock_take_report_listener]);

  return (
    <>
      < Modal isOpen={open} className="modal-dialog-centered" size={"lg"} fullscreen>
        <ModalHeader toggle={loading ? "" : closeModal}>Add Stock Take</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <AuthTenantLoader tenant_info={tenant_info} loading_message={loading_message} />
              </>
              :
              <>
                {
                  <>

                    {error && (
                      <div className="mb-3 w-100">
                        <Alert color="danger" className="alert-icon">
                          <Icon name="alert-circle" /> {error}{" "}
                        </Alert>
                      </div>
                    )}
                    {
                      (failed_imports?.length + successImports?.length) === (imported_data_list?.length) && imported_data_list?.length !== 0 ?
                        <>
                          <Block>
                            <BlockBetween className="mb-4">
                              <BlockHeadContent>
                                <div className="card-inner">
                                  <Button
                                    color="primary"
                                    size="sm"
                                    onClick={handleReUploadClick} // <-- trigger click here
                                  >
                                    Re-Upload CSV
                                  </Button>
                                </div>
                              </BlockHeadContent>
                              <BlockHeadContent>
                                <div className="card-inner">
                                  {
                                    preview_set ?
                                      <>
                                        <Button
                                          color="primary"
                                          size="sm"
                                          onClick={submit_stock_take_report} // <-- trigger click here
                                        >
                                          Submit Report
                                        </Button>
                                      </>
                                      :
                                      <>
                                        <Button
                                          color="primary"
                                          size="sm"
                                          onClick={handleSubmitForPreview} // <-- trigger click here
                                        >
                                          Preview Stock Take
                                        </Button>
                                      </>
                                  }
                                </div>
                              </BlockHeadContent>
                            </BlockBetween>
                          </Block>
                          <Block>
                            <CardTabs
                              cardTabs={tabs}
                              activeCardTab={activeCardTab}
                              setActiveCardTab={setActiveCardTab}
                            />
                          </Block>
                          {
                            activeCardTab === "Valid Data (To Be Imported)" && (
                              <>
                                {
                                  successImports && successImports?.length > 0 ?
                                    <>
                                      <div className="card-inner">
                                        <Block>
                                          <BlockBetween className="mb-4">
                                            <BlockHeadContent>
                                              <BlockTitle tag="h5">Valid Data (To Be Imported)</BlockTitle>
                                            </BlockHeadContent>
                                          </BlockBetween>
                                          <div className="nk-tb-list is-separate is-medium mb-3">
                                            <DataTableHead className="nk-tb-item">
                                              <DataTableRow>
                                                <span className="sub-text">Brand</span>
                                              </DataTableRow>
                                              <DataTableRow size="lg">
                                                <span className="sub-text">Product Name</span>
                                              </DataTableRow>
                                              <DataTableRow size="lg">
                                                <span className="sub-text">Product Type</span>
                                              </DataTableRow>
                                              <DataTableRow size="lg">
                                                <span className="sub-text">Color</span>
                                              </DataTableRow>
                                              <DataTableRow size="lg">
                                                <span className="sub-text">Size</span>
                                              </DataTableRow>
                                              <DataTableRow size="lg">
                                                <span className="sub-text">Physical Stock</span>
                                              </DataTableRow>
                                              <DataTableRow size="lg">
                                                <span className="sub-text">Theoretical Stock</span>
                                              </DataTableRow>
                                              <DataTableRow size="lg">
                                                <span className="sub-text">Variance</span>
                                              </DataTableRow>
                                            </DataTableHead>
                                            {currentSuccessImports.length > 0
                                              ? currentSuccessImports.map((item) => (
                                                <DataTableItem key={item.id}>
                                                  <DataTableRow size="sm">
                                                    <div className="user-card">
                                                      <div className="user-info">
                                                        <span className="tb-lead">
                                                          {item?.category || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                                        </span>
                                                        <span>{item?.product_id || "--"}</span>
                                                      </div>
                                                    </div>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-product">
                                                      <span className="tb-sub">{item?.product_name || "--"}</span>
                                                    </span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.product_type || "--"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.color || "--"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.size || "--"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.physical_stock || "--"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.theoretical_balance || "--"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.variance || "--"}</span>
                                                  </DataTableRow>
                                                </DataTableItem>
                                              ))
                                              : null}
                                          </div>
                                          {currentSuccessImports.length > 0 && (
                                            <div className="mt-3">
                                              <PaginationComponent
                                                itemPerPage={successImportsPerPage}
                                                totalItems={successImports?.length}
                                                paginate={successImportsPaginate}
                                                currentPage={currentSuccessImportsPage}
                                              />
                                            </div>
                                          )}
                                        </Block>
                                      </div>
                                    </>
                                    :
                                    <>
                                      <div className="card-inner">
                                        <Block>
                                          <BlockBetween className="mb-4">
                                            <BlockHeadContent>
                                              <BlockTitle tag="h5">Valid Data (To Be Imported)</BlockTitle>
                                            </BlockHeadContent>
                                          </BlockBetween>
                                        </Block>
                                      </div>
                                      <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Valid Data Found"} />
                                    </>
                                }
                              </>
                            )
                          }
                          {
                            activeCardTab === "Invalid Data (Not To Be Imported)" && (
                              <>
                                {
                                  failed_imports && failed_imports?.length > 0 ?
                                    <>
                                      <div className="card-inner">
                                        <Block>
                                          <BlockBetween className="mb-4">
                                            <BlockHeadContent>
                                              <BlockTitle tag="h5">Invalid Data (Not To Be Imported)</BlockTitle>
                                            </BlockHeadContent>
                                          </BlockBetween>
                                          <div className="nk-tb-list is-separate is-medium mb-3">
                                            <DataTableHead className="nk-tb-item">
                                              <DataTableRow>
                                                <span className="sub-text">Brand</span>
                                              </DataTableRow>
                                              <DataTableRow size="lg">
                                                <span className="sub-text">Product Name</span>
                                              </DataTableRow>
                                              <DataTableRow size="lg">
                                                <span className="sub-text">Product Type</span>
                                              </DataTableRow>
                                              <DataTableRow size="lg">
                                                <span className="sub-text">Color</span>
                                              </DataTableRow>
                                              <DataTableRow size="lg">
                                                <span className="sub-text">Size</span>
                                              </DataTableRow>
                                              <DataTableRow size="lg">
                                                <span className="sub-text">Physical Stock</span>
                                              </DataTableRow>
                                            </DataTableHead>
                                            {currentFailedImports.length > 0
                                              ? currentFailedImports.map((item) => (
                                                <DataTableItem key={item.id}>
                                                  <DataTableRow size="sm">
                                                    <div className="user-card">
                                                      <div className="user-info">
                                                        <span className="tb-lead">
                                                          {item?.category || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                                        </span>
                                                        <span>{item?.product_id || "--"}</span>
                                                      </div>
                                                    </div>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-product">
                                                      <span className="tb-sub">{item?.product_name || "--"}</span>
                                                    </span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.product_type || "--"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.color || "--"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.size || "--"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.physical_stock || "--"}</span>
                                                  </DataTableRow>
                                                </DataTableItem>
                                              ))
                                              : null}
                                          </div>
                                          {currentFailedImports.length > 0 && (
                                            <div className="mt-3">
                                              <PaginationComponent
                                                itemPerPage={currentFailedImportsPage}
                                                totalItems={failed_imports?.length}
                                                paginate={failedImportsPaginate}
                                                currentPage={currentFailedImportsPage}
                                              />
                                            </div>
                                          )}
                                        </Block>
                                      </div>
                                    </>
                                    :
                                    <>
                                      <div className="card-inner">
                                        <Block>
                                          <BlockBetween className="mb-4">
                                            <BlockHeadContent>
                                              <BlockTitle tag="h5">Invalid Data (Not To Be Imported)</BlockTitle>
                                            </BlockHeadContent>
                                          </BlockBetween>
                                        </Block>
                                      </div>
                                      <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Invalid Data Found"} />
                                    </>
                                }
                              </>
                            )
                          }
                          <input
                            type="file"
                            id="csvUpload"
                            accept=".csv,text/csv"
                            style={{ display: 'none' }}
                            onChange={handleCsvUpload}
                            ref={fileInputRef}
                          />
                        </>
                        :
                        <>
                          <div
                            className="product-thumb"
                            style={{
                              height: '250px',
                              width: '100%',
                              position: 'relative',
                              border: '1px dashed #ccc',
                              backgroundColor: '#f9f9f9',
                              overflow: 'hidden',
                            }}
                          >
                            <label
                              htmlFor="csvUpload"
                              style={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                color: '#777',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                fontFamily: 'Arial, sans-serif',
                                cursor: 'pointer',
                                textAlign: 'center',
                              }}
                            >
                              <p style={{ margin: 0 }}>Click to Upload CSV File</p>
                            </label>

                            <input
                              type="file"
                              id="csvUpload"
                              accept=".csv,text/csv"
                              style={{ display: 'none' }}
                              onChange={handleCsvUpload}
                              ref={fileInputRef}
                            />
                          </div>
                        </>
                    }
                  </>
                }
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default UploadStockTakeReportModal;